import { useState, useEffect } from "react";
import { List, Modal } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import { Modals } from "scripts/settings";

const Component = ({ data = {} }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { visible } = state;
	const { hash } = useLocation();
	const navigate = useNavigate();

	const componentDidUpdate = () => {
		if (hash === `#${Modals.INFO}`) {
			setState((prevState) => ({
				...prevState,
				visible: true,
			}));
		} else {
			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Modal
			className="bk-modal-manage"
			footer={false}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title="Info"
		>
			<List>
				{Object.entries(data).map(
					([key, value]) =>
						value instanceof Object || (
							<List.Item key={key}>
								<List.Item.Meta title={`${key}:`} description={`${value}`} />
							</List.Item>
						)
				)}
			</List>
		</Modal>
	);
};

export default Component;
